export default "__VITE_ASSET__D$TsMKp2__"